/**
 * Spec Console の auth API contract（zod schema + 型）。
 *
 * Spec Console は閲覧専用サービスであり、権限による表示分岐を持たない。認証済み社員は
 * 全員が同じ仕様ビューを見るため、本 contract が返すのは「誰としてログインしているか」
 * （ヘッダ表示用）だけで、ロールや操作可否フラグは含めない。
 *
 * ログインは Edge Router Worker（`auth.air-closet.ai`）が所有する。Web は 401 を受け取ったら
 * Edge の認証開始 URL へフルページ遷移するだけで、資格情報を自前で扱わない。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business ログイン中ユーザーの表示情報を API ↔ Web で型共有する。
 * @graph-connects none
 */
import { z } from 'zod';
/** ログイン中ユーザーの表示情報。 @graph-connects none */
export const SpecConsoleUserSchema = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string(),
});
/** `auth.me` のレスポンス。 @graph-connects none */
export const SpecConsoleCurrentUserResponseSchema = z.object({
    user: SpecConsoleUserSchema,
});
//# sourceMappingURL=auth.js.map